import { washInstrumentServices } from '@/services/db'

const state = {
  washInstruments: [],
  washInstrumentsListFormat: []
}

// getters
const getters = {
  getWashInstruments: state => state.washInstruments,
  getWashInstrumentsListFormat: state => state.washInstrumentsListFormat,
}

// actions
const actions = {

  async fetchWashInstruments ({commit}, payload) {
    try {
      commit('setLoading', true, { root: true })

      const res = await washInstrumentServices.fetchWashInstruments(payload)
      const list = []
      res.forEach((v,i) => {
        list.push({text:v.wash_instrument,value:v.id})  
      })
    
      commit('setWashInstrumentsListFormat', list)
      commit('setWashInstruments', res)
      commit('setLoading', false, { root: true })
    } catch (e) {
      console.log(e)
    }
  },

  async updateColumnById ({commit}, payload) {
    /*************************************
    * ID: washInstrument Id                      *
    * field: the field that changed      *
    * value: the new value of that field *
    *************************************/
    
    try {
      commit('setLoading', true, { root: true })

      /* API call here to save data to server */
      /* code here */

      const res = await washInstrumentServices.updateWashInstrumentColumn(payload)

      commit('setLoading', false, { root: true })
    } catch (e) { 
      console.log(e)
    }
  },

  async addWashInstrument ({commit}) {
    try {
      commit('setLoading', true, { root: true })

      /* API call here to server to create new washInstrument */
      /* code here */

      let obj = {
        name: 'New Wash Instrument'
      }

      const res = await washInstrumentServices.addWashInstrument(obj)
      const data = await Promise.resolve([
        ...state.washInstruments,
        res.data
      ])
      commit('setWashInstruments', data)
      commit('setLoading', false, { root: true })
    } catch (e) { 
      console.log(e)
    }
  },
  async sortWashInstrument({commit}, payload){
    commit('setLoading', true, { root: true })
    let title = payload.title;
    let order = payload.order

    let data = []
    if (order){
      data= state.washInstruments.sort((a,b) => a[title].toString().localeCompare(b[title].toString()))
    }else{
      data= state.washInstruments.sort((b,a) => a[title].toString().localeCompare(b[title].toString()))
    }
    commit('setWashInstruments', data)
    commit('setLoading', false, { root: true })
  }

}

// mutations
const mutations = {
  resetWashInstruments (state) {
    state.washInstruments = []
  },

  setWashInstruments (state, payload) {
    state.washInstruments = payload
  },

  setWashInstrumentsListFormat (state, payload) {
    state.washInstrumentsListFormat = payload
  }

  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}